export default __webpack_public_path__ + "static/media/roadmap-head-shark-7.913814aa.png";